import { render, staticRenderFns } from "./ModalCadastroLegislacao.vue?vue&type=template&id=1492ac1e"
import script from "./ModalCadastroLegislacao.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroLegislacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports